module.exports = __webpack_public_path__ + "static/img/sy_bqd.9b71b54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sy/sy_bqd.png
// module id = GKRk
// module chunks = 1